import React from 'react'
import { ControlledHiddenInput, ControlledPhoneInput } from 'transfix-form/components'
import ControlledMultiFileDropzone from 'transfix-form/components/ControlledMultiFileDropzone/ControlledMultiFileDropzone'
import Box from 'transfix-ui/core/Box'
import Typography from 'transfix-ui/core/Typography'
import { INLINE_MESSAGE_VARIANTS, InlineMessage } from 'transfix-ui'
import InsuranceContactInformatiomFormField from './InsuranceContactInformatiomFormField'
import { useAddInsuranceContactInformationModalFormContext } from './useAddInsuranceContactInformationModalForm'
import { getErrorMessage } from './utils'

interface IAddInsuranceContactInformationModalForm {
  carrierApplicationId: string
}
export const AddInsuranceContactInformationModalForm = ({
  carrierApplicationId,
}: IAddInsuranceContactInformationModalForm) => {
  const { control, errors } = useAddInsuranceContactInformationModalFormContext()

  const dropzoneError = getErrorMessage(errors, 'insuranceDocuments')

  return (
    <form data-test='AddInsuranceContactInformationModalForm'>
      <Box display='grid' gap={2} mb={4} mt={4} maxWidth={425}>
        <ControlledHiddenInput
          control={control}
          name='carrierApplicationId'
          defaultValue={carrierApplicationId}
          value={carrierApplicationId}
        />
        <InsuranceContactInformatiomFormField
          name='organizationName'
          label='Insurance Organization Name'
          placeholder='Enter Organization Name'
        />
        <InsuranceContactInformatiomFormField
          name='fullName'
          label="Insurance Agent's Full Name"
          placeholder='Enter Full Name'
        />
        <InsuranceContactInformatiomFormField
          name='email'
          label="Insurance Agent's Email Address"
          placeholder='you@yourcompanyname.com'
          type='email'
        />
        <ControlledPhoneInput
          name='phoneNumber'
          control={control}
          PhoneInputProps={{
            validationMessage: getErrorMessage(errors, 'phoneNumber'),
            invalid: !!getErrorMessage(errors, 'phoneNumber'),
            placeholder: '(555) 123 - 5678',
            required: true,
            dataTest: `input-phoneNumber`,
            label: "Insurance Agent's Phone",
          }}
        />
      </Box>

      <Box mb={2}>
        <Typography variant='subtitle1'>Please upload your certificate(s) of insurance</Typography>
        {dropzoneError && (
          <InlineMessage type={INLINE_MESSAGE_VARIANTS.ALERT} message={dropzoneError} />
        )}
      </Box>
      <ControlledMultiFileDropzone
        name='insuranceDocuments'
        control={control}
        defaultValue={[]}
        MultiDropzoneProps={{
          dropZoneText: 'Upload a file or drop it here',
        }}
      />
    </form>
  )
}
